import config from 'config'
import { Main } from 'components/masters'
import { get } from 'lodash'
import React from 'react'
import * as Page from 'containers/pages'
import { Tabs } from '../../components/layout'


const publicPath = config.publicPath
const routes = [
    {
        path: `${publicPath}/assessors`,
        component: props => (
            <Main params={get(props, 'match.params', {})} {...props}>
                <Page.AssessorsList
                    params={get(props, 'match.params', {})}
                    tabs={<Tabs params={get(props, 'match.params', {})} {...props} />}
                    {...props}
                />
            </Main>
        ),
        routes: [
            {
                path: `${publicPath}/assessors/all`,
                exact: true,
                component: props => (
                    <Page.AssessorsListAll {...props} />
                )
            },
            {
                path: `${publicPath}/assessors/pending`,
                exact: true,
                component: props => (
                    <Page.AssessorPending {...props} />
                )
            },
            {
                path: `${publicPath}/assessors/cpn-expires`,
                exact: true,
                component: props => (
                    <Page.AssessorsListCPNExpires {...props} />
                )
            },
            {
                path: `${publicPath}/assessors/cpn-expired`,
                exact: true,
                component: props => (
                    <Page.AssessorsListCPNExpired {...props} />
                )
            },
            {
                path: `${publicPath}/assessors/archived`,
                exact: true,
                component: props => (
                    <Page.AssessorsListArchived {...props} />
                )
            }
        ]
    },
    {
        path: `${publicPath}/organizations/:organizationId/assessors/:assessorId`,
        component: props => (
            <Main params={get(props, 'match.params', {})} {...props}>
                <Page.Assessor
                    params={get(props, 'match.params', {})}
                    tabs={<Tabs params={get(props, 'match.params', {})} {...props} />}
                    {...props}
                />
            </Main>
        ),
        routes: [
            {
                path: `${publicPath}/organizations/:organizationId/assessors/:assessorId/detail`,
                exact: true,
                component: props => (
                    <Page.AssessorDetail {...props} />
                )
            },
            {
                path: `${publicPath}/organizations/:organizationId/assessors/:assessorId/participants`,
                exact: true,
                component: props => (
                    <Page.AssessorParticipantsDetail {...props} />
                )
            },
            {
                path: `${publicPath}/organizations/:organizationId/assessors/:assessorId/files`,
                exact: true,
                component: props => (
                    <Page.AssessorFiles {...props} />
                )
            },
            {
                path: `${publicPath}/organizations/:organizationId/assessors/:assessorId/history`,
                exact: true,
                component: props => (
                    <Page.AssessorHistory params={get(props, 'match.params', {})} {...props} />
                )
            }
        ]
    }
]

export default routes
